import cAddList from './cAddList.vue';

export default {
  install(Vue) {
    Vue.component('cAddList', cAddList);
  },
};
